export default "__VITE_ASSET__CoCB$42U__"